import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

const FormInputContainer = styled.div`
  background-color: ${props =>
    props.readonly ? 'transparent' : props.theme.colors.blue.five};
  border-radius: ${pxToRem('6px')};
  padding: ${pxToRem('4px')} ${pxToRem('8px')} ${pxToRem('4px')}
    ${pxToRem('4px')};
  // margin-bottom: ${pxToRem('24px')};
  width: 100%
`;

const Label = styled.div`
  padding: ${pxToRem('4px')} ${pxToRem('4px')} ${pxToRem('8px')}
    ${pxToRem('4px')};
  color: ${props => props.theme.colors.grayText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Error = styled.div`
  position: absolute;
  margin-top: ${pxToRem('5px')};
`;

const DotsMenu = styled.div`
  cursor: pointer;
  width: ${pxToRem('16px')};
  height: ${pxToRem('16px')};
  background-image: radial-gradient(
    circle,
    ${props => props.theme.colors.mainBlue} 1px,
    transparent 1px
  );
  background-size: 100% 33.33%;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DotsMenuContainer = styled.div`
  position: relative;
`;

const IconContainer = styled.div`
  cursor: pointer;
  opacity: 0;
  transition: all 250ms;
  ${({ isEditing }) =>
    isEditing &&
    css`
      opacity: 1;
    `}
`;

const FormInputExternalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${pxToRem('5px')};
`;

export {
  FormInputContainer,
  Label,
  Error,
  DotsMenu,
  HeaderContainer,
  DotsMenuContainer,
  IconContainer,
  FormInputExternalContainer
};
